document.addEventListener("DOMContentLoaded", () => {
  const rootEl = document.querySelector("#pdf-flipper");
  if (!rootEl) return;

  const bookEl = document.getElementById("pdf-book");
  const prevBtn = document.getElementById("pdf-prevBtn");
  const nextBtn = document.getElementById("pdf-nextBtn");
  const pageInfo = document.getElementById("pdf-pageInfo");
  const zoomInBtn = document.getElementById("pdf-zoomInBtn");
  const zoomOutBtn = document.getElementById("pdf-zoomOutBtn");
  const zoomResetBtn = document.getElementById("pdf-zoomResetBtn");
  const downloadBtn = document.getElementById("pdf-downloadBtn");

  const paramUrl = new URLSearchParams(location.search).get("pdf");
  const pdfUrl = paramUrl || rootEl.getAttribute("data-pdf");
  if (!pdfUrl) return;

  // ====== Download ======
  function filenameFromUrl(url) {
    try {
      const path = new URL(url, location.href).pathname;
      const base = path.split("/").pop() || "document.pdf";
      return decodeURIComponent(base.split("?")[0]) || "document.pdf";
    } catch {
      return "document.pdf";
    }
  }

  async function downloadPdf() {
    const name = filenameFromUrl(pdfUrl);
    try {
      const res = await fetch(pdfUrl, { mode: "cors" });
      if (!res.ok) throw new Error(`HTTP ${res.status}`);
      const blob = await res.blob();
      const objUrl = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = objUrl;
      a.download = name.endsWith(".pdf") ? name : name + ".pdf";
      document.body.appendChild(a);
      a.click();
      a.remove();
      setTimeout(() => URL.revokeObjectURL(objUrl), 1000);
    } catch {
      window.open(pdfUrl, "_blank", "noopener");
    }
  }

  downloadBtn.addEventListener("click", downloadPdf);

  // ====== Book ======
  const book = PDFlipbook.create(bookEl, {
    url: pdfUrl,
    displayMode: "auto",
    duration: 320, // ms for a full flip/fold; library default (520) reads as sluggish
    maxScale: 3, // cap on devicePixelRatio; PDFlipbook renders sharper on top of this as you zoom in
    zoomSteps: [1, 1.5, 2, 3],
    arrows: false,
    controls: false,
    pageNumbers: false,
    displayMode: "double",
    cornerFold: false,
    pdfjsSrc: rootEl.getAttribute("data-pdfjs-src") || null,
    pdfWorkerSrc: rootEl.getAttribute("data-pdf-worker-src") || null,
  });

  function updateNav(page, pages) {
    pageInfo.textContent = `${page || "–"} / ${pages || "–"}`;
    prevBtn.disabled = page <= 1;
    nextBtn.disabled = pages ? page >= pages : false;
  }

  bookEl.addEventListener("flipbook:ready", (e) => {
    updateNav(book.currentPage(), e.detail.pages);
  });
  bookEl.addEventListener("flipbook:pagechange", (e) => {
    updateNav(e.detail.page, e.detail.pages);
  });
  bookEl.addEventListener("flipbook:error", (e) => {
    console.error("Failed to load/render PDF:", e.detail.error);
    bookEl.innerHTML = "<p>Couldn’t load that PDF.</p>";
  });

  prevBtn.addEventListener("click", () => book.prev());
  nextBtn.addEventListener("click", () => book.next());
  zoomInBtn.addEventListener("click", () => book.zoomIn());
  zoomOutBtn.addEventListener("click", () => book.zoomOut());
  zoomResetBtn.addEventListener("click", () => book.setZoom(1));
});
